import styled from '@emotion/styled';
import { GlobalScore, Title } from '@gameonly/core';
import { useTranslation } from 'react-i18next';
import keyify from '../../project/parameters/keyify';
import { DARK_BLUE, GREEN, LIGHT_GREEN } from '../colors';
import { Bottom, PageLayout } from '../layout';
import { PdfGlobalScore } from '../PdfGlobalScore';
import { SectionTitle } from '../SectionTitle';
import { Footer } from './Footer';

const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  padding: 2.5rem 2.5rem 0 2.5rem;
  width: 100%;
`;

export const IndicatorPage = ({
  title,
  score,
  year,
  pageNumber,
  modelName,
}: {
  title: Title;
  score: GlobalScore;
  year: number | undefined;
  pageNumber: number | undefined;
  modelName: string;
}) => {
  const { t, i18n } = useTranslation();
  const translationPrefix = `model:${keyify(modelName)}`;
  const scoreTranslationPrefix = `${translationPrefix}.result.${score.code?.toLowerCase()}`;

  const pageTitle = t(getIndicatorPageTitleTranslationKey(title, modelName));
  const scoreTitle = t(`${scoreTranslationPrefix}.title`);
  const scoreText = score.score || '';
  const unit = score.unit || '';
  const text = (i18n.language === 'fr' ? score.text_fr : score.text_en) || '';
  const definition = t(`${scoreTranslationPrefix}.description`);
  return (
    <PageLayout
      orientation="portrait"
      style={{
        backgroundColor: DARK_BLUE,
        position: 'relative',
      }}
    >
      <Main>
        <SectionTitle
          title={pageTitle}
          style={{
            background: GREEN,
          }}
        />
        <PdfGlobalScore
          title={scoreTitle}
          score={scoreText}
          unit={unit}
          text={text}
          definition={definition}
          scoreBlockStyle={{
            background: LIGHT_GREEN,
          }}
          definitionBlockStyle={{
            background: LIGHT_GREEN,
          }}
        />
      </Main>

      <Bottom>
        <Footer year={year} pageNumber={pageNumber} />
      </Bottom>
    </PageLayout>
  );
};

export const getIndicatorPageTitleTranslationKey = (
  result: Title,
  modelName: string,
) => {
  return `model:${modelName.toLowerCase()}.result.${result.code?.toLowerCase()}.text`;
};
